import React from 'react';
import { Row, Col, Button, Icon } from 'antd';

import Input from 'components/Fields/Input';
import TextArea from 'components/Fields/TextArea';

export default function FormVehiclesLicense (props) {
  const { vehicles, license } = props;

  return (
    <div style={{ padding: '0 24px 12px', background: '#efefef' }}>
      <h3 style={{ display: 'flex', justifyContent: 'space-between', paddingTop: 12 }}>
        <span>Véhicule autorisé</span>
        <Button
          type="danger"
          disabled={vehicles.licenses.length === 10}
          size="small"
          onClick={() => props.removeVehicles(license.uid)}
        >
          <Icon type="delete" />Supprimer
        </Button>
      </h3>
      <Row gutter={24} align="middle" style={{ background: '#fff' }}>
        <Col md={12} span={24}>
          <Input
            model=".name"
            label="Plaque d'immatriculation du véhicule"
            placeholder="Veuillez saisir l'immatriculation du véhicule"
            errorMessages={{ required: { message: 'Veuillez saisir l\'immatriculation du véhicule' } }}
            defaultValue={license ? license.name : ''}
            autoFocus
          />
        </Col>
        <Col md={12} span={24}>
          <Input
            model=".owner"
            label="Nom et prénom du propriétaire"
            placeholder="Nom prénom"
            errorMessages={{ required: { message: 'Veuillez saisir le nom et prénom du propriétaire' } }}
            defaultValue={license ? license.name : ''}
          />
        </Col>
      </Row>
      <Row gutter={24} style={{ background: '#fff' }}>
        <Col>
          <TextArea
            model=".comment"
            label="Raison du besoin du véhicule"
            errorMessages={{
              required: { message: 'Veuillez saisir une raison' },
              lengthMax: { message: '1500 caractères maximum', rule: val => !val || val.length <= 1500 },
            }}
            defaultValue={license ? license.comment : ''}
          />
        </Col>
      </Row>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Form/FormVehiclesLicense.js